<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active" @click="sort('name')">
				Navn
			</th>
			<th class="sortable active" @click="sort('groupname')">
				Gruppe
			</th>
			<th class="sortable active" @click="sort('info')">
				Info
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(person, index) in (sortedActivity, filteredList)" :key="index" @click="editPerson(person)">
					<td v-text="person.name"></td>
					<td v-text="person.groupname" class="center"></td>
					<td v-text="person.info"></td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(person, index) in (sortedActivity, filteredList)" :key="index" @click="editPerson(person)">
					<td>
						<ul class="flex-content">
							<li data-label="Navn">{{ person.name }}</li>
							<li data-label="Gruppe">{{ person.groupname }}</li>
							<li data-label="Info">{{ person.info }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen personer fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen personer
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "PersonsList",
		data: () => ({
			data: [],
			customerID: null,
			agreementID: null,
			currentSort: "groupname",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html

				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var persons = this.data
				return persons.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var persons = this.data
				return persons.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					let groupname = data.groupname.toLowerCase().match(this.search.toLowerCase());
					return name || groupname;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		mounted()
		{
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid

			if (!this.agreementID || this.agreementID == 0)
			{
				this.agreementID = this.agreementidref
			}

			this.loadData()
		},
		methods:
		{
			getFullname(person)
			{
				return person.information.firstname + " " + person.information.lastname
			},
			async loadData()
			{
				this.setComponentAsBusy()
				let data = { customerid: this.customerID, agreementid: this.agreementID }
				await this.$store.dispatch(types.ACTION_GET_PERSONS, data)
					.then(response =>
					{
						this.data = response.data;
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("PersonsList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},
			editPerson(person)
			{
				this.$router.push({ name: "PersonEdit", params: { personid: person.id } })
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
